import { render, staticRenderFns } from "./ContextMenuHeaders.vue?vue&type=template&id=5c9d6132&"
import script from "./ContextMenuHeaders.vue?vue&type=script&lang=js&"
export * from "./ContextMenuHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports